
<template lang="pug">
  div
    Loader(v-if="loadingData")
    div
      button.btn.btn-primary.float-right(@click="download") 下載目前報告
      h6 <kbd>區間測速資訊</kbd>        
      form.form-inline(@submit.prevent="onFilterSet")
        input.form-control.mr-2(type="text" v-model="medName" placeholder="輸入流水號, 車號或日期")
        button.btn.btn-primary(type="submit") 搜尋
        
      hr
      div
        vuetable(
          ref="vuetable"
          :api-url="`${server}/api/drug-storage-summary/`"
          data-path=""
          :fields="fields"
          :http-options="httpOptions"
          pagination-path=""
          :perPage="30"
          :row-class="onRowClass"
          :css="boostrapCss"
          detail-row-component="adc-drug-detail-drug-storage"
          :append-params="moreParams" 
          @vuetable:cell-clicked="onCellClicked"
        )
          template(slot="total_amount" slot-scope="props")
            span {{props.rowData.total_amount}}

    
</template>

<script>
import Vue from 'vue';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import DrugListDrugStorages from './DrugListDrugStorages';
import ResetLowAmountModal from '../../flowComp/ResetLowAmountLimit';
import Loader from '../../common/Loader';


Vue.component('adc-drug-detail-drug-storage', DrugListDrugStorages);

// 更改安全存量
Vue.component('action', {
  name: 'minAmount',
  props: [
    'rowData',
  ],
  data() {
    return {
      showModal: false,
    };
  },
  components: {
    ResetLowAmountModal,
  },
  computed: {
  },
  methods: {
    async showLowAmountModal() {
      await this.$store.dispatch('getTotalDrugAmountInstanly', this.rowData.id);
      await this.$store.dispatch('getLowAmountLimitData', this.rowData.id);
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.$parent.refresh();
    },
  },
  template: `
    <div>
      <button class="btn-sm btn btn-info" @click="showLowAmountModal">更改安全存量</button>
      <ResetLowAmountModal v-if="showModal" v-on:closeModal="closeModal" :showNumPad="false" :currentAmount="rowData.min_amount" :limitAmount="rowData.total_avalaible_max_amount"></ResetLowAmountModal>
    </div>
  `,
});

export default {
  name: 'ADCDrugList',
  data() {
    return {
      loadingData: false,
      boostrapCss: {
        tableClass: 'table table-bordered table-sm  table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      sortOrder: [
        {
          field: 'device',
          direction: 'asc',
        },
      ],
      fields: [
        {
          name: 'medication.code',
          title: '流水號',
        },
        {
          name: 'medication.CGMH_number',
          title: '車牌號碼',
        },
        {
          name: 'medication.generic_name',
          title: '車別代碼',
          sortField: 'medication.generic_name',
        },
        {
          name: '__slot:total_amount',
          title: '進入時間',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'avaliable_amount',
          title: '離開時間',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        /*
        {
          name: 'min_amount',
          title: '安全存量',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'drug_storage_count',
          title: '藥倉數量',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        */
        {
          name: '__component:action',
          title: '動作',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ],
      server,
      systemType: 'ADC',
      moreParams: {},
      createDrugStorage: true,
      systems: [],
      systemId: undefined,
      devices: [],
      deviceId: '',
      medicines: [],
      stock: 0,
      maxStock: 0,
      date: '',
      batch: '',
      searchDrug: '',
      medName: '',
    };
  },
  components: {
    Vuetable,
    Loader,
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    drugStorageChangedTime() {
      return this.$store.state.drugInDevice.drugStorageChangedTime;
    },
  },
  async mounted() {
    this.loadingData = true;
    await this.getSystem();
    this.loadingData = false;
  },
  methods: {
    onRowClass(data, index) {
      if (data.min_amount >= data.avaliable_amount) {
        return 'low-amount-med';
      }
      return '';
    },
    // for table sorting
    getSortParam(sortOrder) {
      return sortOrder.map((sort) => {
        if (sort.field === 'device') {
          return `${(sort.direction === 'desc' ? '-' : '')}device_id`;
        }
        if (sort.field === 'medication.generic_name') {
          return `${(sort.direction === 'desc' ? '-' : '')}medication__generic_name`;
        }
        return (sort.direction === 'desc' ? '-' : '') + sort.field;
      }).join(',');
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    updateTable() {
      this.moreParams.device__net__system_id = this.systemId;
      this.$refs.vuetable.refresh();
    },
    getSystem() {
      return this.instance.get('/api/system/', {
        params: {
          type: 'ADC',
        },
      })
      .then((res) => {
        this.systems = res.data.results;
      });
    },
    getDeviece() {
      const sys = this.system[this.systemId];
      sys.net_set.forEach((net) => {
        net.device_set.forEach((device) => {
          this.devices.push(device);
        });
      });
    },
    getMedcines() {
      this.instance.get('/api/medication/')
      .then((res) => {
        this.medicines = res.data.results;
      });
    },
    // 表格搜尋功能
    onFilterSet() {
      this.moreParams = {
        search: this.medName,
        system: this.systemId,
      };
      const vm = this;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    // 下載藥倉報告
    download() {
      if (this.systemId) {
        window.open(`${server}/export-ADC-drug-storage/?system=${this.systemId}`, '_blank');
      } else {
        window.open(`${server}/export-ADC-drug-storage/`, '_blank');
      }
    },
  },
  watch: {
    maxStock(val) {
      if (val < this.stock) this.maxStock = this.stock;
    },
    stock(val) {
      if (this.stock > this.maxStock) this.maxStock = this.stock;
    },
    drugStorageChangedTime(val) {
      console.log(val, this.$refs.vuetable.visibleDetailRows);
      this.$refs.vuetable.refresh();
      this.$refs.vuetable.visibleDetailRows.forEach((id) => {
        console.log(id);
        this.$refs.vuetable.toggleDetailRow(id);
        setTimeout(() => {
          this.$refs.vuetable.toggleDetailRow(id);
        }, 100);
      });
    },
  },
};
</script>


<style lang="sass">
.custom-table
  thead
    background-color: steelblue
    color: white
.red-text
  color: red

.low-amount-med
  background-color: rgba(255, 150, 12, 0.6)
</style>




// WEBPACK FOOTER //
// DrugList.vue?7a8635f5